import * as restaurantService from './restaurants'

export default restaurantService;